var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mr-2",attrs:{"small":"","rounded":"","depressed":"","color":"secondary","loading":_vm.loading},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Migrate Bill")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }